import React, { useEffect, useState } from "react";
import { get, omit } from "lodash";
import moment from "moment";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useStores } from "_common/hooks";
import { useForm } from "react-hook-form";

import { observer } from "mobx-react";
import { NotificationManager } from "react-notifications";
import { ProfileApi } from "states/api";
import UploadFile from "_common/component/UploadFile";
import i18next from "i18next";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import KYCForm from "./KYCForm";

const schema = yup
  .object({
    full_name: yup.string().required(i18next.t("verify_require")),
  })
  .required();

const MobileKYC = observer(() => {
  const navigate = useNavigate();
  const {
    authStore: { user },
  } = useStores();
  const queryClient = useQueryClient();
  const [front_images, setFrontImage] = useState();
  const [back_images, setBackImage] = useState();

  const { mutate, isLoading } = useMutation(
    (variables) => ProfileApi.update({ params: variables }),
    {
      onSuccess: (res) => {
        navigate("/member");
        queryClient.invalidateQueries(["get_profile"]);
        NotificationManager.success(
          i18next.t(res?.msg) || i18next.t("action_success_msg")
        );
      },
      onError: (error) => {
        const errorMessage =
          i18next.t(error?.message) ?? i18next.t("action_failed_msg");
        NotificationManager.error(errorMessage);
      },
    }
  );

  const {
    register,
    trigger,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSave = (values) => {
    if (isLoading) return;
    trigger();
    const formValue = getValues();
    const isValid = schema.isValidSync(formValue);
    if (isValid) {
      mutate({
        ...formValue,
        front_image: front_images,
        back_image: back_images,
      });
    }
  };

  const onReceiveFrontImages = (images) => {
    setFrontImage(images[0]?.url);
  };

  const onReceiveBackImages = (images) => {
    setBackImage(images[0]?.url);
  };

  useEffect(() => {
    if (user?.back_image) {
      setBackImage(user?.back_image_url);
    }
    if (user?.front_image) {
      setFrontImage(user?.front_image_url);
    }
  }, [user]);

  return (
    <div className="container !mt-[50px] !pb-[100px]">
      <HeaderTop title="Đã xác minh" />
      <div className="bg-[#121420] py-[5px] px-[15px]">
        <div className="contentbox_line !h-[unset] !bg-[transparent]">
          <div className="w-full p-[10px] text-center">
            <span className="fe6im f12">
              Sau khi hoàn thành xác thực thực tế, bạn có thể nhận được các
              quyền và lợi ích tương ứng
            </span>
          </div>
        </div>
        <KYCForm />
      </div>
    </div>
  );
});

export default MobileKYC;
